export default __webpack_public_path__ + "static/media/100_it.61679a2b.xls";